import React, { useState, useEffect } from 'react';
import { Container, Stack, Grid, Box, FormControl, TextField, Button, Card, CardContent, Typography, CircularProgress, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions} from "@mui/material";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import axios from 'axios';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { ContextSession } from "../../services/ContextSession";
import { useContext } from "react";

function CrearUsuarios() {
    const sessi = useContext(ContextSession);
    const [valor, setValor] = useState('');
    const [datos, setDatos] = useState(null);
    const [error, setError] = useState('');
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false); // Estado para manejar la carga
    const [checkboxChecked, setCheckboxChecked] = useState(false); // Estado para el Checkbox
    const [nombreUsuario, setNombreUsuario] = useState(''); // Estado para el nombre de usuario generado
    const [identidadConsultada, setIdentidadConsultada] = useState('');
    const [correoIngresado, setCorreoIngresado] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');

    const handleCheckboxChange = (event) => {
        const isChecked = event.target.checked;
        setCheckboxChecked(isChecked);
        if (isChecked) {
            setTimeout(() => {
                window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
            }, 100);
        }
    };

    const handleChange = (event) => {
        const valorIngresado = event.target.value;
        const regex = /^[0-9]+$/; // Solo números

        if (regex.test(valorIngresado)) {
            setValor(valorIngresado);
        } else {
            setValor(''); // o puedes mostrar un error
        }
    };

    const handleChangeCorreo = (event) => {
        setCorreoIngresado(event.target.value);

    };

    const consultarAPI = async () => {
        setLoading(true); // Comienza la carga
        try {
            const response = await axios.post(`${sessi.ip}/api/datos/`, {
                dni: valor
            });

            if (response.data.error) {
                setError(response.data.error);
                setDatos(null);
            } else {
                const informacion = response.data.informacion;

                // Validar que informacion no sea null o undefined
                if (!informacion) {
                    setError('No se recibió información válida de la API');
                    setDatos(null);
                } else {
                    const nuevosDatos = {
                        nombre: `${informacion[0]?.split(': ')[1] ?? ''} ${informacion[1]?.split(': ')[1] ?? ''} ${informacion[2]?.split(': ')[1] ?? ''} ${informacion[3]?.split(': ')[1] ?? ''}`,
                        nacimiento: informacion[4]?.split(': ')[1] ?? '',
                        direccion: informacion[5]?.split(': ')[1] ?? '',
                        telefono: informacion[7]?.split(': ')[1] ?? '',
                        telefonotrabajo: informacion[8]?.split(': ')[1] ?? '',
                        correo: informacion[9]?.split(': ')[1] ?? '',
                        direcciontrabajo: informacion[10]?.split(': ')[1] ?? '',
                        area: informacion[11]?.split(': ')[1] ?? '',
                        fechacreacion: informacion[12]?.split(': ')[1] ?? '',
                        fecharegistro: informacion[13]?.split(': ')[1] ?? '',
                        departamento: informacion[14]?.split(': ')[1] ?? '',
                        municipio: informacion[15]?.split(': ')[1] ?? '',
                        colonia: informacion[16]?.split(': ')[1] ?? '',
                        estadocivil: informacion[17]?.split(': ')[1] ?? '',
                        nacionalidad: informacion[18]?.split(': ')[1] ?? '',
                        sexo: informacion[19]?.split(': ')[1] ?? '',
                        pais: informacion[20]?.split(': ')[1] ?? '',
                        profesion: informacion[21]?.split(': ')[1] ?? ''
                    };

                    setDatos(nuevosDatos);
                    setIdentidadConsultada(valor);
                    setError('');
                }
            }
            setVisible(true);
        } catch (error) {
            setError('No se encontró información válida para el DNI proporcionado');
            setVisible(true);
        }
        setLoading(false); // Termina la carga
    };

    useEffect(() => {
        if (datos) {
            generarNombreUsuario();
        }
    }, [datos]);

    // Generar nombre de usuario
    const generarNombreUsuario = () => {
        if (datos) {
            const nombres = datos.nombre.split(' ');
            const primerNombre = nombres[0] || '';
            const primerApellido = nombres[2] || '';
            const segundoApellido = nombres[3] || '';
            const letraPrimerNombre = primerNombre.charAt(0).toLowerCase();
            const letraPrimerApellido = primerApellido.toLowerCase();
            const letraSegundoApellido = segundoApellido.charAt(0).toLowerCase();
            const numerosRandom = Math.floor(100 + Math.random() * 900); // Genera 3 números aleatorios
            const nfinal = `${letraPrimerNombre}${letraPrimerApellido}${letraSegundoApellido}${numerosRandom}`;
            setNombreUsuario(nfinal);
        }
    };

    const cambiarNumerosRandom = () => {
        const nombres = datos.nombre.split(' ');
        const primerNombre = nombres[0] || '';
        const primerApellido = nombres[2] || '';
        const segundoApellido = nombres[3] || '';
        const letraPrimerNombre = primerNombre.charAt(0).toLowerCase();
        const letraPrimerApellido = primerApellido.toLowerCase();
        const letraSegundoApellido = segundoApellido.charAt(0).toLowerCase();
        const numerosRandom = Math.floor(100 + Math.random() * 900); // Genera 3 números aleatorios nuevos
        const nfinal = `${letraPrimerNombre}${letraPrimerApellido}${letraSegundoApellido}${numerosRandom}`;
        setNombreUsuario(nfinal);
    };

    const validarCampos = () => {
        if (!identidadConsultada) return 'DNI';
        if (!datos.nombre) return 'Nombre Completo';
        if (!nombreUsuario) return 'Usuario';
        if (!correoIngresado) return 'Correo';
        if (!datos.telefono) return 'Teléfono';
        return null;
    };

    const handleCrearUsuario = async () => {
        const campoVacio = validarCampos();
        if (campoVacio) {
            setDialogMessage(`El campo ${campoVacio} está vacío y debe ser ingresado.`);
            setDialogOpen(true);
            return;
        }

        try {
            await axios.post(`${sessi.ip}/api/part/crear/posts/`, {
                DNI: identidadConsultada,
                NombreCompleto: datos.nombre,
                Usuario: nombreUsuario,
                Correo: correoIngresado,
                Telefono: datos.telefono
            });

            setDialogMessage('Usuario creado con éxito');
        } catch (error) {
            if (error.response && error.response.status === 400 && error.response.data.detail === 'El usuario ya existe.') {
                setDialogMessage('El usuario ya existe');
            } else {
                setDialogMessage('Error al crear el usuario');
            }
        }

        setDialogOpen(true);
    };

    return (
        <>
            <Container>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
                    <h2><b>Crear Usuarios</b></h2>
                </div>

                <Stack direction="row" justifyContent="center" alignItems="center">
                    <Stack direction="row" spacing={5} justifyContent="space-between" alignItems="center">
                        <FormControl sx={{ m: 1, width: 250 }}>
                            <TextField
                                id="NumeroIdentidad"
                                label="Número de Identidad"
                                placeholder="Identidad sin espacios ni guiones"
                                variant="filled"
                                value={valor}
                                onChange={handleChange}
                                inputProps={{ maxLength: 13 }} // Limitar la longitud máxima a 13 caracteres
                            />
                        </FormControl>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: 'var(--color-surface-muted)',
                                '&:hover': {
                                    backgroundColor: 'var(--color-brand-secondary)',
                                    color: 'var(--color-white)'
                                },
                            }}
                            onClick={consultarAPI}
                            disabled={valor.length !== 13} // Deshabilitar si no tiene 13 dígitos
                        >
                            Consultar
                        </Button>
                    </Stack>
                </Stack>

                {loading && (
                    <Box display="flex" justifyContent="center" marginTop={2}>
                        <CircularProgress />
                    </Box>
                )}

                {visible && (
                    <div id="my-container">

                        <Box marginTop={2} boxShadow={3}>
                            <Card variant='elevation'>
                                <CardContent>
                                    {error ? (
                                        <>
                                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                <img src={process.env.PUBLIC_URL + '/error.jpg'} alt="Error" style={{ marginRight: 10, width: 130, height: 130 }} />
                                                <Typography color="error" style={{ flexGrow: 1, textAlign: 'center' }}>{error}</Typography>
                                            </Box>
                                        </>
                                    ) : (
                                        <>
                                            <Stack direction="row">
                                                <Grid container spacing={1}>
                                                    <FormControl sx={{ m: 1, flexGrow: 2 }}>
                                                        <TextField
                                                            id="nombre"
                                                            label="Nombre Completo"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.nombre}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                                        <TextField
                                                            id="nacimiento"
                                                            label="Fecha De Nacimiento"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.nacimiento}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                                        <TextField
                                                            id="direccion"
                                                            label="Dirección"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.direccion}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Stack>

                                            <Stack direction="row">
                                                <Grid container spacing={1}>
                                                    <FormControl sx={{ m: 1, flexGrow: 2 }}>
                                                        <TextField
                                                            id="telefono"
                                                            label="Teléfono Móvil"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.telefono}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                                        <TextField
                                                            id="telefonotrabajo"
                                                            label="Teléfono Trabajo"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.telefonotrabajo}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                                        <TextField
                                                            id="correo"
                                                            label="Correo"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.correo}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Stack>

                                            <Stack direction="row">
                                                <Grid container spacing={1}>
                                                    <FormControl sx={{ m: 1, flexGrow: 2 }}>
                                                        <TextField
                                                            id="direcciontrabajo"
                                                            label="Dirección Trabajo"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.direcciontrabajo}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                                        <TextField
                                                            id="area"
                                                            label="Área Trabajo"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.area}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                                        <TextField
                                                            id="fechacreacion"
                                                            label="Fecha Creación"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.fechacreacion}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Stack>

                                            <Stack direction="row">
                                                <Grid container spacing={1}>
                                                    <FormControl sx={{ m: 1, flexGrow: 2 }}>
                                                        <TextField
                                                            id="fecharegistro"
                                                            label="Fecha Registro"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.fecharegistro}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                                        <TextField
                                                            id="departamento"
                                                            label="Departamento"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.departamento}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                                        <TextField
                                                            id="municipio"
                                                            label="Municipio"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.municipio}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Stack>

                                            <Stack direction="row">
                                                <Grid container spacing={1}>
                                                    <FormControl sx={{ m: 1, flexGrow: 2 }}>
                                                        <TextField
                                                            id="colonia"
                                                            label="Colonia"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.colonia}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                                        <TextField
                                                            id="estadocivil"
                                                            label="Estado Civil"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.estadocivil}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                                        <TextField
                                                            id="nacionalidad"
                                                            label="Nacionalidad"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.nacionalidad}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Stack>

                                            <Stack direction="row">
                                                <Grid container spacing={1}>
                                                    <FormControl sx={{ m: 1, flexGrow: 2 }}>
                                                        <TextField
                                                            id="sexo"
                                                            label="Sexo"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.sexo}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                                        <TextField
                                                            id="pais"
                                                            label="País de Nacimiento"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.pais}
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                                        <TextField
                                                            id="profesion"
                                                            label="Profesión"
                                                            variant="filled"
                                                            InputProps={{ readOnly: true }}
                                                            size="small"
                                                            value={datos.profesion}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Stack>
                                        </>
                                    )}
                                </CardContent>
                            </Card>
                        </Box>
                    </div>
                )}

                {visible && !error && (
                    <FormControlLabel
                        style={{ marginTop: '10px' }}
                        required
                        control={<Checkbox color="error" checked={checkboxChecked} onChange={handleCheckboxChange} />}
                        label="Certifico que la información del participante es correcta."
                    />
                )}

                {checkboxChecked && !error && (
                    <>
                        <Stack direction="row">
                            <Grid container alignItems="center">
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="usuario"
                                        label="Nombre de Usuario"
                                        variant="filled"
                                        InputProps={{ readOnly: true }}
                                        size="small"
                                        value={nombreUsuario}
                                    />
                                </FormControl>
                                <Tooltip title="Cambiar nombre de usuario" placement='top'
                                    slotProps={{
                                        popper: {
                                            sx: {
                                                [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                                                {
                                                    marginTop: '0px',
                                                },
                                                [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                                                {
                                                    marginBottom: '0px',
                                                },
                                                [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                                                {
                                                    marginLeft: '0px',
                                                },
                                                [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                                                {
                                                    marginRight: '0px',
                                                },
                                            },
                                        },
                                    }}
                                >
                                    <IconButton color="primary" onClick={cambiarNumerosRandom}>
                                        <ChangeCircleIcon />
                                    </IconButton>
                                </Tooltip>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        type='email'
                                        id="confirmarcorreo"
                                        label="Confirmar Correo"
                                        variant="filled"
                                        size="small"
                                        onChange={handleChangeCorreo}
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>

                        <Box marginTop={2} textAlign="center">
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: 'var(--color-surface-muted)',
                                    '&:hover': {
                                        backgroundColor: 'var(--color-brand-secondary)',
                                        color: 'var(--color-white)'
                                    },
                                }}
                                onClick={handleCrearUsuario}
                            >
                                Crear Usuario
                            </Button>
                        </Box>
                    </>
                )}

                <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                    <DialogTitle>Información</DialogTitle>
                    <DialogContent>
                        <DialogContentText>{dialogMessage}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDialogOpen(false)} color="primary">Cerrar</Button>
                    </DialogActions>
                </Dialog>

            </Container>
        </>
    );
}

export default CrearUsuarios;



